import {
  DSIconBlocked,
  DSIconButton,
  DSIconConversation,
  DSIconFilter,
  DSIconPlus,
  DSIconReview,
  Row,
  Text,
  css,
} from "@cdx/ds";
import {useState} from "react";
import {SetActions} from "../../../../lib/hooks/useSet";
import {TooltipForChild} from "@cdx/common";
import {Resolvable} from "../../../../cdx-models/Resolvable";
import {getCountByField} from "../../../../lib/collection-utils";

const filterTypes = {
  block: {
    sortIndex: 1,
    buttonContent: <DSIconBlocked />,
    name: "block",
    activeTooltip: "Filter for block threads.",
    inactiveTooltip: "This card has never been blocked.",
  },
  review: {
    sortIndex: 2,
    buttonContent: <DSIconReview />,
    name: "review",
    activeTooltip: "Filter for reviews.",
    inactiveTooltip: "There are no reviews on this card.",
  },
  comment: {
    sortIndex: 3,
    buttonContent: <DSIconConversation />,
    name: "comment",
    activeTooltip: "Filter for comment threads.",
    inactiveTooltip: "There are no comment threads on this card.",
  },
} as const;

const ConversationHeader = (props: {
  activeFilters: Set<string>;
  activeFiltersActions: SetActions<string>;
  resolvables: Resolvable[];
  toggleNewThread: () => void;
  newThreadType: null | "review" | "block" | "comment";
}) => {
  const {activeFilters, activeFiltersActions, resolvables, toggleNewThread, newThreadType} = props;
  const [showFilters, setShowFilters] = useState(false);

  const handleToggle = () => {
    setShowFilters((v) => !v);
    if (activeFilters.size) activeFiltersActions.clear();
  };

  const resTypeCounts = getCountByField(resolvables, "context");

  return (
    <Row sp="12px" align="center">
      {!showFilters && (
        <Text type="label11Caps" color="secondary">
          Conversations
        </Text>
      )}
      <TooltipForChild tooltip="Filter conversations by type">
        <DSIconButton
          variant="secondary"
          active={showFilters}
          onClick={handleToggle}
          size="sm"
          icon={<DSIconFilter />}
          className={css({ml: "auto"})}
        />
      </TooltipForChild>
      {showFilters && (
        <Row sp="8px">
          {Object.values(filterTypes).map((f) => (
            <TooltipForChild
              key={f.name}
              tooltip={resTypeCounts.has(f.name) ? f.activeTooltip : f.inactiveTooltip}
            >
              <DSIconButton
                icon={f.buttonContent}
                label={`${resTypeCounts.get(f.name) ?? 0}`}
                variant="secondary"
                size="sm"
                active={activeFilters.has(f.name)}
                onClick={() => activeFiltersActions.toggle(f.name)}
                disabled={!resTypeCounts.has(f.name)}
              />
            </TooltipForChild>
          ))}
        </Row>
      )}
      {process.env.REACT_APP_MODE === "open" ||
      newThreadType === "block" ||
      newThreadType === "review" ||
      showFilters ? null : (
        <TooltipForChild tooltip="Start new comment thread.">
          <DSIconButton
            size="sm"
            active={Boolean(newThreadType)}
            onClick={toggleNewThread}
            icon={<DSIconPlus />}
            label="New"
          />
        </TooltipForChild>
      )}
    </Row>
  );
};

export default ConversationHeader;
